(()=>{
  if(window.irrigaWholeProductCardInstalled)return;
  window.irrigaWholeProductCardInstalled=true;
  const controls='a,button,input,select,textarea,label,summary,[role="button"],[role="link"],[contenteditable="true"],quick-add-modal,quick-view-modal,modal-opener,quick-add-opener,quick-view-opener,quantity-input,product-swatch,variant-selects';
  let gesture=null;
  document.addEventListener('pointerdown',event=>{
    const card=event.target.closest('.product-card-wrapper');
    gesture=card?{card,x:event.clientX,y:event.clientY,moved:false}:null;
  },{passive:true});
  document.addEventListener('pointermove',event=>{
    if(gesture&&Math.hypot(event.clientX-gesture.x,event.clientY-gesture.y)>8)gesture.moved=true;
  },{passive:true});
  document.addEventListener('pointercancel',()=>{gesture=null;});
  function navigate(event){
    if(window.Shopify?.designMode||event.defaultPrevented)return;
    if(event.type==='click'&&event.button!==0)return;
    if(event.type==='auxclick'&&event.button!==1)return;
    const card=event.target.closest('.product-card-wrapper');
    if(!card||event.target.closest(controls))return;
    if(gesture?.card===card&&gesture.moved){gesture=null;return;}
    if(window.getSelection()?.toString())return;
    const href=card.dataset.productUrl||card.querySelector('a[href*="/products/"]')?.getAttribute('href');
    if(!href)return;
    const url=new URL(href,location.href);
    if(url.origin!==location.origin||!url.pathname.includes('/products/'))return;
    event.preventDefault();
    gesture=null;
    if(event.ctrlKey||event.metaKey||event.shiftKey||event.button===1)window.open(url.href,'_blank','noopener');
    else location.assign(url.href);
  }
  document.addEventListener('click',navigate);
  document.addEventListener('auxclick',navigate);
})();
